function hexToRgb(hex: string) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((char) => char + char)
            .join('');
    }

    const r = Number.parseInt(hex.slice(0, 2), 16);
    const g = Number.parseInt(hex.slice(2, 4), 16);
    const b = Number.parseInt(hex.slice(4, 6), 16);

    return { r, g, b };
}

function luminance(r: number, g: number, b: number) {
    const a = [r, g, b].map((v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

export function contrastRatio(luminance1: number, luminance2: number) {
    return (luminance1 + 0.05) / (luminance2 + 0.05);
}

export function getBestContrastColor(hex: string) {
    const rgb: { r: number; g: number; b: number } = hexToRgb(hex);
    const lum = luminance(rgb.r, rgb.g, rgb.b);

    const whiteLum = 1; // Luminanza del bianco
    const blackLum = 0; // Luminanza del nero

    const contrastWithWhite = contrastRatio(whiteLum, lum);
    const contrastWithBlack = contrastRatio(lum, blackLum);
    return contrastWithWhite > contrastWithBlack ? '#FFF' : '#333';
}
